<template>
  <div id="app" class="app-root">
    <div class="app-content">
      <router-view></router-view>
    </div>
    <div class="app-footer">
      <span>Copyright © 深圳男科实验质评中心 </span>
      <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备14019749号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app'

}
</script>

<style>
.app-root {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.app-content {
  flex: 1;
}
.app-footer {
  text-align: center;
  padding: 12px 0;
  font-size: 13px;
  color: #999;
  background: #f5f5f5;
  border-top: 1px solid #e8e8e8;
  flex-shrink: 0;
}
.app-footer a {
  color: #999;
  text-decoration: none;
}
.app-footer a:hover {
  color: #409eff;
  text-decoration: underline;
}
</style>
